import { DefaultErrorHandler, HTTP } from '@/utils/http-common'

export default {
  // Admin endpoints
  createExportAdmin($, data) {
    return new Promise((resolve, reject) => {
      HTTP.post('/bnc/exports/admin/', data)
        .then((response) => {
          $.$store.commit('success', 'Export created successfully')
          resolve(response)
        })
        .catch((error) => {
          $.$store.commit('error', { msg: error.message, color: 'error' })
          reject(error)
        })
    })
  },

  updateExportAdmin($, id, data) {
    return new Promise((resolve, reject) => {
      HTTP.patch(`/bnc/exports/admin/${id}/`, data)
        .then((response) => {
          $.$store.commit('success', 'Export updated successfully')
          resolve(response)
        })
        .catch((error) => {
          $.$store.commit('error', { msg: error.message, color: 'error' })
          reject(error)
        })
    })
  },

  listExportsAdmin($, page = 1, pageSize = 20, project = null) {
    const params = { page, size: pageSize }
    if (project) params.project = project

    return new Promise((resolve, reject) => {
      HTTP.get('/bnc/exports/admin/', { params })
        .then((response) => resolve(response))
        .catch((error) => {
          $.$store.commit('error', { msg: error.message, color: 'error' })
          reject(error)
        })
    })
  },

  filterExports($, params, page = 1, pageSize = 20) {
    return new Promise((resolve, reject) => {
      HTTP.get('/bnc/exports/admin/', {
        params: {
          ...params,
          page,
          size: pageSize,
        },
      })
        .then((response) => resolve(response))
        .catch((error) => {
          $.$store.commit('error', { msg: error.message, color: 'error' })
          reject(error)
        })
    })
  },

  getExportAdmin($, id) {
    return new Promise((resolve, reject) => {
      HTTP.get(`/bnc/exports/admin/${id}/`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          $.$store.commit('error', { msg: error.message, color: 'error' })
          reject(error)
        })
    })
  },

  deleteExportAdmin($, id) {
    return new Promise((resolve, reject) => {
      HTTP.delete(`/bnc/exports/admin/${id}/`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          $.$store.commit('error', { msg: error.message, color: 'error' })
          reject(error)
        })
    })
  },

  generateExportAdmin($, id) {
    return new Promise((resolve, reject) => {
      HTTP.post(`/bnc/exports/admin/${id}/export/`, null, {
        responseType: 'blob',
      })
        .then((response) => {
          if (response.status === 204) {
            $.$store.commit('success', $.$t('emptyExport'))
            return resolve()
          }
          $.$store.commit('success', $.$t('successExport'))

          let filename = id + '.xlsx'
          const link = document.createElement('a')
          link.href = window.URL.createObjectURL(new Blob([response.data]))
          link.download = filename
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
          resolve(link)
        })
        .catch((error) => {
          $.$store.commit('error', {
            msg: $.$t('errorExport') + '\n' + error.message,
            color: 'error',
          })
          reject(error)
        })
    })
  },

  listAllFiles($, page = 1, pageSize = 20, project = null, export_id = null) {
    const params = { page, size: pageSize }
    if (project) params.project = project
    if (export_id) params.export = export_id

    return new Promise((resolve, reject) => {
      HTTP.get('/bnc/exports/admin/files/', { params })
        .then((response) => resolve(response))
        .catch((error) => {
          $.$store.commit('error', { msg: error.message, color: 'error' })
          reject(error)
        })
    })
  },

  filterFiles($, params, page = 1, pageSize = 20) {
    return new Promise((resolve, reject) => {
      HTTP.get('/bnc/exports/admin/files/', {
        params: {
          ...params,
          page,
          size: pageSize,
        },
      })
        .then((response) => resolve(response))
        .catch((error) => {
          $.$store.commit('error', { msg: error.message, color: 'error' })
          reject(error)
        })
    })
  },

  // Project endpoints
  createExport($, data) {
    return new Promise((resolve, reject) => {
      HTTP.post('/bnc/exports/', data)
        .then((response) => {
          $.$store.commit('success', 'Export created successfully')
          resolve(response)
        })
        .catch((error) => {
          $.$store.commit('error', { msg: error.message, color: 'error' })
          reject(error)
        })
    })
  },

  updateExport($, id, data) {
    return new Promise((resolve, reject) => {
      HTTP.patch(`/bnc/exports/${id}/`, data)
        .then((response) => {
          $.$store.commit('success', 'Export updated successfully')
          resolve(response)
        })
        .catch((error) => {
          $.$store.commit('error', { msg: error.message, color: 'error' })
          reject(error)
        })
    })
  },

  listExports($, page = 1, pageSize = 20) {
    return new Promise((resolve, reject) => {
      HTTP.get('/bnc/exports/', {
        params: {
          page,
          size: pageSize,
        },
      })
        .then((response) => resolve(response))
        .catch((error) => {
          $.$store.commit('error', { msg: error.message, color: 'error' })
          reject(error)
        })
    })
  },

  getExport($, id) {
    return new Promise((resolve, reject) => {
      HTTP.get(`/bnc/exports/${id}/`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          $.$store.commit('error', { msg: error.message, color: 'error' })
          reject(error)
        })
    })
  },

  deleteExport($, id) {
    return new Promise((resolve, reject) => {
      HTTP.delete(`/bnc/exports/${id}/`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          $.$store.commit('error', { msg: error.message, color: 'error' })
          reject(error)
        })
    })
  },

  generateExport($, id) {
    return new Promise((resolve, reject) => {
      HTTP.post(`/bnc/exports/${id}/export/`, null, {
        responseType: 'blob',
      })
        .then((response) => {
          if (response.status === 204) {
            $.$store.commit('success', $.$t('emptyExport'))
            return resolve()
          }
          $.$store.commit('success', $.$t('successExport'))

          let filename = id + '.xlsx'
          const link = document.createElement('a')
          link.href = window.URL.createObjectURL(new Blob([response.data]))
          link.download = filename
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
          resolve(link)
        })
        .catch((error) => {
          $.$store.commit('error', {
            msg: $.$t('errorExport') + '\n' + error.message,
            color: 'error',
          })
          reject(error)
        })
    })
  },

  listProjectFiles($, page = 1, pageSize = 20, export_id = null) {
    const params = { page, size: pageSize }
    if (export_id) params.export = export_id

    return new Promise((resolve, reject) => {
      HTTP.get('/bnc/exports/files/', { params })
        .then((response) => resolve(response))
        .catch((error) => {
          $.$store.commit('error', { msg: error.message, color: 'error' })
          reject(error)
        })
    })
  },

  deleteFile($, id) {
    return new Promise((resolve, reject) => {
      HTTP.delete(`/bnc/exports/files/${id}/`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          $.$store.commit('error', { msg: error.message, color: 'error' })
          reject(error)
        })
    })
  },

  // Download file
  retrieveFile($, id, filename) {
    return new Promise((resolve, reject) => {
      HTTP.get(`/bnc/exports/files/${id}/`, {
        responseType: 'blob',
      })
        .then((response) => {
          const link = document.createElement('a')
          link.href = window.URL.createObjectURL(new Blob([response.data]))
          link.download = filename
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
          resolve(link)
        })
        .catch((err) => DefaultErrorHandler($, err, reject))
    })
  },
}
